module.exports = __webpack_public_path__ + "static/img/METEL_QRCODE@2x.87e7074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/METEL_QRCODE@2x.png
// module id = mu96
// module chunks = 1